var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldCameraSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.679 2.229-18.45 18.46c-.3.3-.3.79 0 1.09a.758.758 0 0 0 1.08-.01l18.46-18.46c.31-.3.31-.78 0-1.08-.3-.3-.79-.3-1.09 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.83 3.66C15.37 2.75 14.17 2 13.15 2h-2.29c-1.03 0-2.23.75-2.69 1.66l-.72 1.45C7.17 5.65 6.61 6 6 6 3.83 6 2.11 7.83 2.25 9.99l.52 8.26c.05.85.26 1.64.71 2.27L18 6c-.61 0-1.17-.35-1.45-.89l-.72-1.45zM6.5 10.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3c.41 0 .75.34.75.75s-.34.75-.75.75h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.23 18.248c-.13 2.06-1.23 3.75-3.99 3.75H7.41c-.89 0-1.34-1.08-.71-1.71l2.47-2.47c.31-.31.79-.35 1.18-.13.69.39 1.52.54 2.4.35 1.27-.27 2.3-1.31 2.55-2.59.17-.86.02-1.67-.36-2.34-.22-.39-.19-.88.13-1.19l4.5-4.5a.965.965 0 0 1 1.45.11c.52.68.79 1.54.73 2.46l-.52 8.26z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldCameraSlash);
export default __webpack_public_path__ + "static/media/vuesax-bold-camera-slash.9c452d379acf3497988fbed407ccbcf2.svg";
export { ForwardRef as ReactComponent };